import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import MenuLayout from './components/MenuLayout';
import MentalHealthAssessment from './pages/healthAssessment/MentalHealthAssessment';
import AssessmentResults from './pages/healthAssessment/AssessmentResults';
import DepressionAssessment from './pages/healthAssessment/DepressionAssessment';
import SignIn from './pages/register&signIn/SignIn';
import Register from './pages/register&signIn/Register';
import ForgetPassword from './pages/register&signIn/ForgetPassword';
import ChangePassword from './pages/register&signIn/ChangePassword';

import ThaiD from './pages/register&signIn/ThaiD';
import RegisterThaid from './pages/register&signIn/RegisterThaid';
import PublicRoute from './router/PublicRoute';
import PrivateRoute from './router/PrivateRoute';
import HealthNews from './pages/healthNews/HealthNews';
import ShowNews from './pages/healthNews/ShowNews';
import MyHealth from './pages/myHealth/MyHealth';
import ELearningOverview from './pages/e-learning/ELearningOverview';
import ManageELearning from './pages/e-learning/ManageELearning';
import ImportHealthData from './pages/importHealthData/ImportHealthData';
import SummaryAnalysis from './pages/summaryAnalysis/SummaryAnalysis';
import UsageLog from './pages/usageLog/UsageLog';
import HealthSummaryDashboard from './pages/healthSummaryDashboard/HealthSummaryDashboard';
import AllCategory from './pages/e-learning/AllCategories'
import AddCourse from './pages/e-learning/AddCourse';
import Assessment from './pages/healthAssessment/Assessment';
import HealthBehaviorSurvey from './pages/healthAssessment/HealthBehaviorSurvey';
import ManageUsers from './pages/informationManager/UsersManager';
import AddUser from './pages/informationManager/UserAdd';
import EditUser from './pages/informationManager/UserEdit';
import PositionManager from './pages/informationManager/PositionManager';
import PositionEdit from './pages/informationManager/PositionEdit';
import PositionOrderEdit from './pages/informationManager/PositionOrderEdit';
import PositionAdd from './pages/informationManager/PositionAdd';
import HospitalManager from './pages/informationManager/HospitalManager';
import HospitalEdit from './pages/informationManager/HospitalEdit';
import HospitalAdd from './pages/informationManager/HospitalAdd';
import DepartmentManager from './pages/informationManager/DepartmentManager';
import DepartmentEdit from './pages/informationManager/DepartmentEdit';
import DepartmentAdd from './pages/informationManager/DepartmentAdd';
import NewsManager from './pages/informationManager/NewsManager';
import NewsEdit from './pages/informationManager/NewsEdit';
import NewsAdd from './pages/informationManager/NewsAdd';
import HealthBehaviorSurveyResults from './pages/healthAssessment/HealthBehaviorSurveyResults';
import ManageUserELearning from './pages/e-learning/user/ManageUserELearning';
import ShowCourse from './pages/e-learning/user/ShowCourse';
import TestBeforeClass from './pages/e-learning/user/TestBeforeClass';
import Classroom from './pages/e-learning/user/Classroom';
import TestAfterClass from './pages/e-learning/user/TestAfterClass';
import EditCourse from './pages/e-learning/EditCourse';
import EditPersonalHealthData from './pages/importHealthData/editPersonalHealthData';
import Profile from './pages/Profile';
import News from 'pages/News';
import UserTypeAdd from 'pages/informationManager/UserTypeAdd';
import ViewAllHistory from 'pages/e-learning/user/ViewAllHistory';
import ManageAssessment from 'pages/healthAssessment/manageAssessment';
import AddAssessment from 'pages/healthAssessment/addAssessment';
import InterpretationManager from 'pages/informationManager/InterpretationManager';
import InterpretationEdit from 'pages/informationManager/InterpretationEdit';
import EditAssessment from 'pages/healthAssessment/editAssessment';
import ManagePromote from 'pages/healthPromotion/ManagePromote';
import AddProjectPromote from 'pages/healthPromotion/AddProjectPromote';
import EditProjectPromote from 'pages/healthPromotion/EditProjectPromote';
import ParticipantScreening from 'pages/healthPromotion/ParticipantScreening';
import ListOfAllParticipants from 'pages/healthPromotion/ListOfAllParticipants';
import SelectedLists from 'pages/healthPromotion/SelectedLists';
import InterpretationAdd from 'pages/informationManager/InterpretationAdd';
import AssessmentDetail from 'pages/healthAssessment/AssessmentDetail';
import AssessmentResultDetail from 'pages/healthAssessment/AssessmentResultDetail';
import AssessmentResult from './pages/healthAssessment/AssessmentResult';
import CoordinateContact from 'pages/coordinateContact/CoordinateContact';
import AddCoordinate from 'pages/coordinateContact/AddCoordinate';
import EditCoordinate from 'pages/coordinateContact/EditCoordinate';
import DetailsCoordinate from 'pages/coordinateContact/DetailsCoordinate';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { refreshToken } from 'store/authAction';

function App() {
  const dispatch = useDispatch()
  const auth = useSelector(state => state.auth)
  useEffect(() => {
    let interval

    if (auth.isAuthenticated) {
      interval = setInterval(() => {
        dispatch(refreshToken())
      }, 5 * 60 * 1000)
    }

    return () => {
      if (interval) clearInterval(interval)
    }
  }, [auth.isAuthenticated])

  return (
    <div className="bg__dashboard">

      <Router>

        <Routes>
          <Route path='/' element={<News />} />
          <Route path='/showNews' element={<ShowNews />} />
          <Route path='/login' element={
            <PublicRoute>
              <SignIn />
            </PublicRoute>
          } />
          <Route path='/register' element={<Register />} />
          <Route path='/thaid' element={<ThaiD />} />
          <Route path='/registerThaid' element={<RegisterThaid />} />
          <Route path='/forgetPassword' element={<ForgetPassword />} />
          <Route path='/changePassword' element={<ChangePassword />} />
        </Routes>

        <Routes>
          <Route element={
            <PrivateRoute>
              <MenuLayout />
            </PrivateRoute>
          }>
            <Route path='/profile' element={<Profile />} />

            {/* เมนูแบบประเมินสุขภาพ */}
            <Route path='/assessment' element={<Assessment />} />
            <Route path='/assessmentDetail' element={<AssessmentDetail />} />
            <Route path='/assessmentResultDetail' element={<AssessmentResultDetail />} />
            <Route path='/healthBehaviorSurvey' element={<HealthBehaviorSurvey />} />
            <Route path='/healthBehaviorSurveyResults' element={<HealthBehaviorSurveyResults />} />
            <Route path='/mentalHealthAssessment' element={<MentalHealthAssessment />} />
            <Route path='/assessmentResult' element={<AssessmentResult />} />
            <Route path='/depressionAssessment' element={<DepressionAssessment />} />
            {/*ผลการประเมินทั้งหมด*/}
            <Route path='/manageAssessment' element={<ManageAssessment />} />
            <Route path='/addAssessment' element={<AddAssessment />} />
            <Route path='/editAssessment' element={<EditAssessment />} />

            {/* เมนูข่าวสารสุขภาพ */}
            <Route path='/healthNews' element={<HealthNews />} />

            {/* เมนูแดชบอร์ดสรุปสุขภาพ */}
            <Route path='/healthSummaryDashboard' element={<HealthSummaryDashboard />} />

            {/* เมนูสุขภาพของฉัน */}
            <Route path='/myHealth' element={<MyHealth />} />

            {/* เมนูE-Learning */}
            <Route path='/eLearningOverview' element={<ELearningOverview />} />
            <Route path='/manageELearning' element={<ManageELearning />} />
            <Route path='/allCategories' element={<AllCategory />} />
            <Route path='/addCourse' element={<AddCourse />} />
            <Route path='/editCourse' element={<EditCourse />} />
            <Route path='/manageUserELearning' element={<ManageUserELearning />} />
            <Route path='/showCourse' element={<ShowCourse />} />
            <Route path='/testBeforeClass' element={<TestBeforeClass />} />
            <Route path='/testAfterClass' element={<TestAfterClass />} />
            <Route path='/classroom' element={<Classroom />} />
            <Route path='/viewAllHistory' element={<ViewAllHistory />} />

            {/* เมนูจัดการข้อมูล */}
            <Route path='/manageUsers' element={<ManageUsers />} />
            <Route path='/addUser' element={<AddUser />} />
            <Route path='/editUser' element={<EditUser />} />
            <Route path='/addUserType' element={<UserTypeAdd />} />

            {/* เมนูจัดการข้อมูล-จัดการข่าวสารสุขภาพ */}
            <Route path='/newsManager' element={<NewsManager />} />
            <Route path='/newsEdit' element={<NewsEdit />} />
            <Route path='/newsAdd' element={<NewsAdd />} />

            {/* เมนูจัดการข้อมูล-จัดการยศ */}
            <Route path='/positionManager' element={<PositionManager />} />
            <Route path='/positionEdit' element={<PositionEdit />} />
            <Route path='/positionOrderEdit' element={<PositionOrderEdit />} />
            <Route path='/positionAdd' element={<PositionAdd />} />

            {/* เมนูจัดการข้อมูล-จัดการโรงพยาบาล */}
            <Route path='/hospitalManager' element={<HospitalManager />} />
            <Route path='/hospitalEdit' element={<HospitalEdit />} />
            <Route path='/hospitalAdd' element={<HospitalAdd />} />

            {/* เมนูจัดการข้อมูล-จัดการสังกัด */}
            <Route path='/departmentManager' element={<DepartmentManager />} />
            <Route path='/departmentEdit' element={<DepartmentEdit />} />
            <Route path='/departmentAdd' element={<DepartmentAdd />} />

            {/* เมนูจัดการข้อมูล-จัดการเกณฑ์แปลผล */}
            <Route path='/manageProcessing' element={<InterpretationManager />} />
            <Route path='/interpretationEdit' element={<InterpretationEdit />} />
            <Route path='/interpretationAdd' element={<InterpretationAdd />} />

            {/* เมนูนำเข้าข้อมูลสุขภาพ */}
            <Route path='/importHealthData' element={<ImportHealthData />} />
            <Route path='/editPersonalHealthData' element={<EditPersonalHealthData />} />

            {/* เมนูสรุปวิเคราะห์ */}
            <Route path='/summaryAnalysis' element={<SummaryAnalysis />} />

            {/* เมนูLog การใช้งาน */}
            <Route path='/usageLog' element={<UsageLog />} />

            {/* เมนูงานสร้างเสริม */}
            <Route path='/managePromote' element={<ManagePromote />} />
            <Route path='/addProjectPromote' element={<AddProjectPromote />} />
            <Route path='/editProjectPromote' element={<EditProjectPromote />} />
            <Route path='/participantScreening' element={<ParticipantScreening />} />
            <Route path='/listOfAllParticipants' element={<ListOfAllParticipants />} />
            {/* <Route path='/contactPromoter' element={<ContactPromoter/>} /> */}
            <Route path='/selectedLists' element={<SelectedLists />} />

            {/* เมนูติดต่อประสานงาน */}
            <Route path='/community' element={<CoordinateContact />} />
            <Route path='/addCoordinate' element={<AddCoordinate />} />
            <Route path='/editCoordinate' element={<EditCoordinate />} />
            <Route path='/detailsCoordinate' element={<DetailsCoordinate />} />

          </Route>
        </Routes>

      </Router>

    </div>
  );
}

export default App;